var _a;
const LAYOUT_MENU_ITEM_IDS = {
  Solutions: 1,
  SuccessStories: 2,
  Resources: 3,
  Support: 4,
  // Sub-menu items under Resources
  NewsInsights: 7,
  AgentToolkit: 8,
  Academy: 9,
  TeamOS: 10
};
const LAYOUT_MENU_ITEMS = [{
  parent: 0,
  id: LAYOUT_MENU_ITEM_IDS.Solutions,
  title: {
    rendered: "Solutions"
  },
  url: "#",
  columns: [{
    heading: "Our Solutions",
    description: "Explore our complete suite of professional tools designed to grow your business.",
    links: [{
      title: "Explore our solutions",
      url: "/agents/solutions/"
    }]
  }, {
    heading: "Grow Your Business",
    links: [{
      title: "Zillow Pro",
      url: "/agents/zillow-pro/"
    }, {
      title: "Premier Agent",
      url: "/agents/premier-agent/"
    }, {
      title: "Media Experts",
      url: "/agents/media-experts/"
    }, {
      title: "Showcase",
      url: "/agents/showcase/"
    }, {
      title: "Zillow Preview",
      url: "/agents/preview/"
    }]
  }, {
    heading: "Power Your Work",
    links: [{
      title: "Workspace",
      url: "/workspace/"
    }, {
      title: "Follow Up Boss",
      url: "https://www.followupboss.com/",
      target: "_blank"
    }, {
      title: "dotloop",
      url: "https://www.dotloop.com/",
      target: "_blank"
    }, {
      title: "ShowingTime",
      url: "https://showingtime.com",
      target: "_blank"
    }]
  }]
}, {
  parent: 0,
  id: LAYOUT_MENU_ITEM_IDS.SuccessStories,
  title: {
    rendered: "Success Stories"
  },
  url: "/agents/success-stories/"
}, {
  parent: 0,
  id: LAYOUT_MENU_ITEM_IDS.Resources,
  title: {
    rendered: "Resources"
  },
  url: "#"
}, {
  parent: LAYOUT_MENU_ITEM_IDS.Resources,
  id: LAYOUT_MENU_ITEM_IDS.NewsInsights,
  title: {
    rendered: "News & Insights"
  },
  url: "/agents/blog/"
}, {
  parent: LAYOUT_MENU_ITEM_IDS.Resources,
  id: LAYOUT_MENU_ITEM_IDS.AgentToolkit,
  title: {
    rendered: "Agent Toolkit"
  },
  url: "/agents/toolkit/"
}, {
  parent: LAYOUT_MENU_ITEM_IDS.Resources,
  id: LAYOUT_MENU_ITEM_IDS.Academy,
  title: {
    rendered: "Zillow Academy Training"
  },
  url: "https://academy.zillowgroup.com",
  target: "_blank"
}, {
  parent: LAYOUT_MENU_ITEM_IDS.Resources,
  id: LAYOUT_MENU_ITEM_IDS.TeamOS,
  title: {
    rendered: "Team OS Growth Podcast"
  },
  url: "https://www.realestateteamos.com/",
  target: "_blank"
}, {
  parent: 0,
  id: LAYOUT_MENU_ITEM_IDS.Support,
  title: {
    rendered: "Support"
  },
  url: "/agents/support/"
}];
const HEADER_CTAS = {
  primary: {
    label: "Contact Sales",
    url: "/agents/contact/"
  },
  secondary: {
    label: "Sign in"
  }
};
const resourcesFooterLinks = LAYOUT_MENU_ITEMS.filter((item) => item.parent === LAYOUT_MENU_ITEM_IDS.Resources);
const getMenuItemById = (id) => {
  return LAYOUT_MENU_ITEMS.find((item) => item.id === id);
};
const solutionsMenu = getMenuItemById(LAYOUT_MENU_ITEM_IDS.Solutions);
const SOLUTIONS_OUR_URL = "/agents/solutions/";
const SOLUTIONS_ADDITIONAL_LINKS = ((_a = solutionsMenu == null ? void 0 : solutionsMenu.columns) == null ? void 0 : _a.flatMap((column, columnIndex) => {
  var _a2;
  if (columnIndex === 0) {
    return ((_a2 = column.links) == null ? void 0 : _a2.slice(1)) || [];
  }
  return column.links || [];
})) || [];
const FOOTER_COLUMNS = [{
  title: "Solutions",
  description: "",
  links: [{
    title: "Our Solutions",
    url: SOLUTIONS_OUR_URL
  }, ...SOLUTIONS_ADDITIONAL_LINKS]
}, {
  title: "Resources",
  description: "",
  links: [...resourcesFooterLinks.map((item) => {
    return {
      title: item.title.rendered,
      url: item.url,
      ...item.target && {
        target: item.target
      }
    };
  }), {
    title: "Success Stories",
    url: "/agents/success-stories/"
  }, {
    title: "Get Support",
    url: "/agents/support/"
  }]
}];
export {
  FOOTER_COLUMNS,
  HEADER_CTAS,
  LAYOUT_MENU_ITEMS,
  LAYOUT_MENU_ITEM_IDS
};
